import _ from 'lodash';
import hasValidToken from './onLoadShared/hasValidToken';

export function redirectAfterLogin() {
  const redirect = _.defaultTo(localStorage.getItem('login-redirect-path'), '/');
  localStorage.removeItem('login-redirect-path');
  window.location.assign(redirect);
}

export const onLoadSharedImpl = async () => {
  const authToken = _.defaultTo(localStorage.getItem('auth-token'), '');
  // can remove split check when all old tokens are gone
  if (await hasValidToken(authToken.split('.').length === 3 ? '' : authToken)) {
    redirectAfterLogin();
    return true;
  }
  return false;
};

export default function onLoadShared() {
  return onLoadSharedImpl;
}
